import llamaTokenizer from "llama-tokenizer-js";
import type { Token } from "./types";

export const tokenize = (text: string, hideSpecialTokens = true): Token[] => {
  const tokens: Token[] = [];
  for (const [index, id] of llamaTokenizer.encode(text).entries()) {
    if (id < 3) {
      if (hideSpecialTokens) {
        continue;
      }

      if (id === 0) {
        tokens.push([id, "<unk>"]);
      } else if (id === 1) {
        tokens.push([id, "<s>"]);
      } else if (id === 2) {
        tokens.push([id, "</s>"]);
      }
    } else if (id === 13) {
      tokens.push([id, "\\n"]);
    } else if (id <= 258) {
      tokens.push([id, llamaTokenizer.vocabById[id]]);
    } else {
      const add_preceding_space = index !== 1;
      const add_bos_token = false;
      tokens.push([
        id,
        llamaTokenizer.decode([id], add_bos_token, !add_preceding_space), // counterintuitively, add_preceding_space removes space added when parameter is set to true when calling encode
      ]);
    }
  }

  return tokens;
};
